import { Character } from "../ui/characters.interface";

export class UtilData {

    public static sexoList: Character[] = [
        { value: 'MASCULINO', viewValue: 'MASCULINO' },
        { value: 'FEMENINO', viewValue: 'FEMENINO' }
    ];
    
    public static maritalStatusList: Character[] = [
        { value: 'ESPOS@', viewValue: 'ESPOS@' },
        { value: 'CONYUGUE', viewValue: 'CONYUGUE' },
        { value: 'HIJO', viewValue: 'HIJO' },
        { value: 'HIJA', viewValue: 'HIJA' }
    ];

    public static civilStatusList: Character[] = [
        { value: 'SOLTERO', viewValue: 'SOLTERO' },
        { value: 'CONCUBINATO', viewValue: 'CONCUBINATO' },
        { value: 'CONCUBINATO', viewValue: 'CASADO' }
    ];

    public static plantaList: Character[] = [
        { value: 'MONTERREY', viewValue: 'MONTERREY' },
        { value: 'TORREON', viewValue: 'TORREON' },
        { value: 'CELAYA', viewValue: 'CELAYA' },
        { value: 'PLASTICOS', viewValue: 'PLASTICOS' },
        { value: 'ESCOBEDO', viewValue: 'ESCOBEDO' },
        { value: 'CIENEGA DE FLORES', viewValue: 'CIENEGA DE FLORES' },
        { value: 'OPTIMA', viewValue: 'OPTIMA' },
        { value: 'POWER FRAME', viewValue: 'POWER FRAME' }
    ];
}